import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Usermenu from "@meetyoo/components/src/components/Appbar/Usermenu";
import ErrorModal from "@meetyoo/components/src/components/Modal/ErrorModal";

import { logout, resetLogoutError } from "../../../actions/oauth";
import OAuthHandler from "../../../lib/OAuthHandler";

const usermenuEntries = logoutHandler => {
  return [
    {
      title: "Logout",
      func: () => {
        OAuthHandler.logout();
        logoutHandler();
      },
    },
  ];
};

export const AppbarUsermenuComponent = ({ logoutHandler, resetErrorHandler, errorLogout }) => {
  return [
    <Usermenu key="menu" entries={usermenuEntries(logoutHandler)} />,
    <ErrorModal
      key="modal"
      errorMessage={errorLogout}
      openErrorModal={errorLogout !== "No Message"}
      handleCloseErrorModal={() => {
        resetErrorHandler();
      }}
    />,
  ];
};

AppbarUsermenuComponent.propTypes = {
  logoutHandler: PropTypes.func.isRequired,
  resetErrorHandler: PropTypes.func.isRequired,
  errorLogout: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  errorLogout: state.oauth.errorLogout,
});

const mapDispatchToProps = {
  logoutHandler: () => (dispatch, getState) => dispatch(logout(getState().oauth.username)),
  resetErrorHandler: () => dispatch => dispatch(resetLogoutError()),
};

const AppbarUsermenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppbarUsermenuComponent);

export default AppbarUsermenu;
